import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { LinkVariant, Size } from '@constants/common/ui.constants';

const useStyles = makeStyles<{
  variant: LinkVariant;
  size: Size;
  isUnderline: boolean;
  inLine: boolean;
}>()((theme, { variant, size, isUnderline, inLine }) => ({
  box: {
    ...(inLine && {
      display: 'inline',
    }),
  },
  linkItem: {
    ...dFlex('start'),
    transition: 'all 250ms ease-in-out',
    fontWeight: 400,

    ...(inLine && {
      display: 'inline',
    }),

    ...(size === Size.Medium && {
      fontSize: 14,
      lineHeight: '20px',
    }),

    ...(size === Size.Small && {
      fontSize: 12,
      lineHeight: '16px',
    }),

    '& svg': {
      marginLeft: 4,
    },

    ...(variant === LinkVariant.Primary && {
      color: theme.primary.p3,

      ...(isUnderline && {
        textDecoration: 'underline',
        textUnderlineOffset: 4,
      }),

      '&:hover': {
        color: theme.secondary.s4,
      },

      '&:focused': {
        color: theme.secondary.s4,
      },

      '&:active': {
        color: theme.secondary.s4,
      },

      '&:disabled': {
        color: theme.secondary.s1,
      },
    }),

    ...(variant === LinkVariant.Light && {
      color: theme.primary.p2,

      '&:hover': {
        color: theme.primary.p3,
      },

      '&:focused': {
        color: theme.primary.p3,
      },

      '&:active': {
        color: theme.primary.p3,
      },

      '&:disabled': {
        color: theme.secondary.s2,
      },
    }),
  },
}));

export default useStyles;
